import React from 'react';

const StarDivider = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        margin: '1rem 0',
        color: '#d4cc00',
        fontSize: '1.2rem',
        letterSpacing: '0.5rem',
      }}
    >
      ★ ★ ★ ★ ★
    </div>
  );
};
export default StarDivider;
